<script>
import {
  SimulationAnthropicWorksDamLake,
  SimulationAnthropicWorksDerivation,
  SimulationAnthropicWorksHydroPlant
} from "@/libs/SimulationData";
import {round} from "@/libs/Helpers";
import constants from "@/libs/Constants";
import {anthropicWorkBadgeColorClass, getWaterInfrastructureTypeI18NLabel} from "@/libs/Helpers";

import {LayerAreasSelectable} from "@/libs/Layers";
import {VariableConfiguration} from "@/libs/VisualizationData";

export default {
  props: {
    propId: String,
    propMonth: {type: String, default: ''},
    propShowMunicipalities: {type: Boolean, default: false},

    //Configuration of variable for selected layer
    propLayerVariableConfiguration: {type: VariableConfiguration, default: null},

    //List of layer and available areas
    propLayerAreasSelectable: {type: LayerAreasSelectable, default: null},

    //Hovered area from results to show info
    propLayerHoverFeatureId: {type: Number, default: null},

    //Hovered water infrastructure work
    propHoverWaterInfrastructureObject: Object,

    propToggle: Boolean,
    propShowClickMessage: {type: Boolean, default: true}
  },
  watch: {
    propToggle(newValue, oldValue) {
      if (newValue !== oldValue)
        this.$emit('onLayerUpdated')
    }
  },
  data() {
    return {
      constants,
      SimulationAnthropicWorksDamLake,
      SimulationAnthropicWorksDerivation,
      SimulationAnthropicWorksHydroPlant
    }
  },
  methods: {
    layerAreaItemsCountTotal() {
      return this.propLayerAreasSelectable !== null ? this.propLayerAreasSelectable.layersCount : 0;
    },
    layerAreaItemsCountSelected() {
      return this.propLayerAreasSelectable !== null ? this.propLayerAreasSelectable.layersSelectedCount : 0;
    },
    layerAreaSelectedOneName() {
      return this.layerAreaItemsCountSelected() === 1 ? this.propLayerAreasSelectable.layerSelectedOneName : ''
    },
    layerAreasManySelectedAverage() {
      let valueStr = '';
      if (this.propLayerAreasSelectable !== null) {
        let value = this.propLayerAreasSelectable.layersSelectedValueAverage;
        if (value !== null) {
          valueStr = `${value}`;
          if (this.propLayerVariableConfiguration !== null && this.propLayerVariableConfiguration.unit !== null)
            valueStr = `${valueStr} ${this.propLayerVariableConfiguration.unit}`
        }
      }
      return valueStr;
    },
    statusCheckHoverWaterInfrastructure() {
      return this.propHoverWaterInfrastructureObject !== null;
    },
    statusCheckHoverArea() {
      return this.propLayerHoverFeatureId !== null && this.propLayerAreasSelectable !== null;
    },
    statusCheckLayerAreasSelected() {
      return this.propLayerAreasSelectable !== null && this.propLayerAreasSelectable.layersSelectedCount > 0;
    },
  },
  computed: {
    infoMode() {
      let infoMode;

      if (this.statusCheckHoverWaterInfrastructure())
        infoMode = constants.INFO_MODE.WATER_INFRASTRUCTURE;
      else if (this.propLayerVariableConfiguration !== null || this.hasHoveredOrSelectedArea === true)
        infoMode = constants.INFO_MODE.RESULTS;
      else
        infoMode = constants.INFO_MODE.WATER_INFRASTRUCTURE;

      return infoMode;
    },

    waterInfrastructureModelType() {
      let modelTypes = [
        {type: constants.LAYERS.DAM_LAKE, cls: SimulationAnthropicWorksDamLake},
        {type: constants.LAYERS.DERIVATION, cls: SimulationAnthropicWorksDerivation},
        {type: constants.LAYERS.PLANT, cls: SimulationAnthropicWorksHydroPlant}
      ];

      let modelType = null;
      modelTypes.forEach(modelItem => {
        if (this.propHoverWaterInfrastructureObject instanceof modelItem.cls) {
          modelType = modelItem.type;
          return;
        }
      });
      return modelType;
    },
    waterInfrastructureModelTypeLabel() {
      let modelType = getWaterInfrastructureTypeI18NLabel(this.waterInfrastructureModelType);
      return modelType !== null ? this.$t(modelType) : '';
    },
    waterInfrastructureModelClickable() {
      let clickable = false;
      if (this.statusCheckHoverWaterInfrastructure() === true)
        switch (this.waterInfrastructureModelType) {
          case constants.LAYERS.DAM_LAKE:
          case constants.LAYERS.DERIVATION:
          case constants.LAYERS.PLANT:
            clickable = this.propHoverWaterInfrastructureObject.editable;
            break;
        }
      return clickable;
    },

    waterInfrastructureBadgeColorClass() {
      return anthropicWorkBadgeColorClass(this.waterInfrastructureModelType);
    },

    modelName() {
      let modelName = null;

      if (this.statusCheckHoverWaterInfrastructure() === true) {
        switch (this.waterInfrastructureModelType) {
          case constants.LAYERS.DAM_LAKE:
          case constants.LAYERS.DERIVATION:
          case constants.LAYERS.PLANT:
            modelName = this.propHoverWaterInfrastructureObject.name
            break;
        }
      } else if (this.statusCheckHoverArea() === true) {
        modelName = this.layerAreaHoverName;
      } else if (this.statusCheckLayerAreasSelected() === true) {
        modelName = this.layerAreaItemsCountSelected() === 1 ? this.layerAreaSelectedOneName() : '';
      }
      return modelName;
    },

    modelData() {
      let modelData = {};

      if (this.statusCheckHoverWaterInfrastructure() === true) {
        /**** Water infrastructure data ****/
        switch (this.waterInfrastructureModelType) {
          case constants.LAYERS.DAM_LAKE:
            if (this.propHoverWaterInfrastructureObject.editable === true)
              modelData = {
                'WorksInputs.RegulationVolume': {
                  label: round(this.propHoverWaterInfrastructureObject.dischargeTurbineFlow, 1),
                  usePill: true
                }
              }
            break;
          case constants.LAYERS.DERIVATION:
            if (this.propHoverWaterInfrastructureObject.editable === true)
              modelData = {
                'WorksInputs.DischargeDerivation': {
                  label: this.propHoverWaterInfrastructureObject.dischargeDerivation === true ?
                      this.$t('WorksInputs.DischargeDerivationStatus.Open') :
                      this.$t('WorksInputs.DischargeDerivationStatus.Closed'),
                  usePill: true
                }
              };
            break;
          case constants.LAYERS.PLANT:
            if (this.propHoverWaterInfrastructureObject.editable === true)
              modelData = {
                'WorksInputs.DischargeMaximumTurbine': {
                  label: round(this.propHoverWaterInfrastructureObject.dischargeTurbineMaximum, 1),
                  usePill: true
                }
              };
            break;
        }
      } else if (this.hasHoveredOrSelectedArea === true) {
        /**** Area data (hovered | selected) ****/
        let altitudeValue = null;
        let municipalities = null;

        if (this.propLayerHoverFeatureId !== null) {
          altitudeValue = this.propLayerAreasSelectable.featureAltitudeRound(this.propLayerHoverFeatureId);
          municipalities = this.propLayerAreasSelectable.featureMunicipalities(this.propLayerHoverFeatureId);
        } else {
          altitudeValue = this.propLayerAreasSelectable.layersSelectedAltitudeAverage;
        }

        if (altitudeValue !== null)
          modelData['WorksInputs.Altitude'] = {
            label: `${altitudeValue} ${this.$t('Units.AboveSeaLevel')}`,
            usePill: true
          }

        if (this.propShowMunicipalities === true && municipalities !== null)
          modelData['SimulationInputs.Municipalities'] = {
            label: municipalities,
            usePill: false
          }
      }

      return modelData;
    },

    variableMultipleSelection() {
      return this.propLayerVariableConfiguration !== null ? this.propLayerVariableConfiguration.area_multiple_selection : false;
    },

    hasHoveredOrSelectedArea() {
      return this.statusCheckHoverArea() || this.statusCheckLayerAreasSelected();
    },

    layerAreaHoverName() {
      return this.statusCheckHoverArea() ?
          this.propLayerAreasSelectable.featureAreaName(this.propLayerHoverFeatureId) :
          '';
    },

    layerAreaHoverOrSelectedValue() {
      let value = '';
      if (this.statusCheckHoverArea())
        value = this.propLayerAreasSelectable.featureValueUnitStr(this.propLayerHoverFeatureId, this.$i18n)
      else if (this.layerAreaItemsCountSelected() > 0) {
        value = this.layerAreasManySelectedAverage();
      }
      return value;
    },
  }
}
</script>

<template>
  <div :id="propId" class="control-layer control-layer-info bg-white-opacity-80">
    <!-- Layer information -->
    <div class="row">
      <div class="col">
        <span class="h6 text-primary me-1">{{ $t('SimulationInputs.Simulation') }}</span>
        <span class="fw-bold">
          <template v-if="infoMode === constants.INFO_MODE.WATER_INFRASTRUCTURE">
            {{ $t('SimulationInputs.AnthropicWorks') }}
          </template>
          <template v-if="infoMode === constants.INFO_MODE.RESULTS">
            {{ propLayerVariableConfiguration.getNameI18N($i18n.locale) }}
          </template>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <template v-if="infoMode === constants.INFO_MODE.RESULTS">
          <span class="badge rounded-pill bg-secondary me-1">{{ $t('SimulationInputs.Month') }}</span>
          <span class="text-capitalize">{{ propMonth }}</span>
        </template>
      </div>
    </div>

    <!-- Information for hovered area / selected areas -->
    <div class="row mt-2">
      <div class="col">
        <!-- Water infrastructure / area data -->
        <template v-if="statusCheckHoverWaterInfrastructure() === true || hasHoveredOrSelectedArea === true">
          <table class="table table-sm table-responsive table-bg-white-opacity-0 m-0 me-1"
                 :class="{'table-borderless': Object.keys(modelData).length === 0}">
            <thead>

            <!-- Water infrastructure data -->
            <tr v-if="statusCheckHoverWaterInfrastructure() === true">
              <td colspan="2" class="text-center title">
                <span class="me-1 fw-semibold text-dark" v-if="modelName !== '' && modelName !== null">
                  {{ modelName }}
                </span>
                <span class="badge rounded-pill"
                      :class="waterInfrastructureBadgeColorClass">{{ waterInfrastructureModelTypeLabel }}</span>
              </td>
            </tr>

            <!-- Area name/value -->
            <tr v-else-if="hasHoveredOrSelectedArea === true">
              <td class="text-start title">
                <span class="me-1 fw-semibold text-dark">
                  <template v-if="statusCheckHoverArea() || layerAreaItemsCountSelected() < 2">
                    {{ modelName }}
                  </template>
                  <template v-else>
                    {{ $t('InputSearchFormLabelValue.MeanSelectedAreas') }}
                  </template>
                </span>
              </td>
              <td class="text-end">
                <span class="badge rounded-pill text-bg-purple table-value">
                  {{ layerAreaHoverOrSelectedValue }}
                </span>
              </td>
            </tr>

            </thead>
            <tbody>
            <template v-for="(value, key) in modelData">
              <tr>
                <td class="text-start table-key">
                  <span class="me-1">{{ $t(key) }}</span>
                </td>
                <td class="text-end">
                  <span :class="{
                    'badge rounded-pill text-bg-purple table-value': value.usePill === true,
                    'small': value.usePill === false
                  }">
                  {{ value.label }}
                  </span>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </template>

        <!-- No data hovered / selected -->
        <template v-else>
          <template v-if="infoMode === constants.INFO_MODE.WATER_INFRASTRUCTURE">
            <p class="fst-italic lh-1 m-0 p-0 text-center my-2">
              <span class="me-1">{{ $t('SimulationInformation.hoverData') }}</span>
            </p>
          </template>
          <template v-if="infoMode === constants.INFO_MODE.RESULTS">
            <p class="fst-italic lh-1 m-0 p-0 text-center my-2">
              <span class="me-1">{{ $t('layerInfo.hoverData') }}</span>
            </p>
          </template>
        </template>
      </div>
    </div>
    <div class="row text-center text-secondary fst-italic my-1"
         v-if="
          infoMode === constants.INFO_MODE.WATER_INFRASTRUCTURE &&
          propShowClickMessage === true &&
          waterInfrastructureModelClickable === true">
      <div class="col">
        <span>{{ $t('SimulationInformation.clickData') }}</span>
      </div>
    </div>

    <div class="row text-end text-secondary" v-if="infoMode === constants.INFO_MODE.RESULTS">
      <div class="col" v-if="variableMultipleSelection === true">
        <span class="fw-bold">{{ layerAreaItemsCountSelected() }}/{{ layerAreaItemsCountTotal() }}</span>
        {{ $tc('layerInfo.selectedElements', layerAreaItemsCountSelected()) }}
      </div>
      <div class="col" v-else>
        <span>{{ $t('layerInfo.clickDataOnlyOne') }}</span>
      </div>
    </div>
  </div>
</template>